/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoDocumentVerifyInput = {
    clientMutationId?: string | null;
    slug: string;
};
export type UnlinkedTaxAssessmentsVerifyMutationVariables = {
    input: infoDocumentVerifyInput;
};
export type UnlinkedTaxAssessmentsVerifyMutationResponse = {
    readonly infoDocumentVerify: {
        readonly clientMutationId: string | null;
    } | null;
};
export type UnlinkedTaxAssessmentsVerifyMutation = {
    readonly response: UnlinkedTaxAssessmentsVerifyMutationResponse;
    readonly variables: UnlinkedTaxAssessmentsVerifyMutationVariables;
};



/*
mutation UnlinkedTaxAssessmentsVerifyMutation(
  $input: infoDocumentVerifyInput!
) {
  infoDocumentVerify(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoDocumentVerifyPayload",
    "kind": "LinkedField",
    "name": "infoDocumentVerify",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnlinkedTaxAssessmentsVerifyMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnlinkedTaxAssessmentsVerifyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c34598336f31c6ac74374fb61262729d",
    "id": null,
    "metadata": {},
    "name": "UnlinkedTaxAssessmentsVerifyMutation",
    "operationKind": "mutation",
    "text": "mutation UnlinkedTaxAssessmentsVerifyMutation(\n  $input: infoDocumentVerifyInput!\n) {\n  infoDocumentVerify(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '03298fd94104445e8e9008cf3ddc5f0b';
export default node;
